export default "__VITE_ASSET__ChlSYDZ5__"